"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const gameHeight_1 = __importDefault(require("../../constants/gameHeight"));
const gameWidth_1 = __importDefault(require("../../constants/gameWidth"));
const drawRectangle_1 = __importDefault(require("./drawRectangle"));
const drawText_1 = __importDefault(require("./drawText"));
const drawBedHUD = () => {
    const offset = 8;
    (0, drawRectangle_1.default)("#000000", .5, gameWidth_1.default / 2 - 42, gameHeight_1.default / 2 - 26 - offset, 84, 15, 10004);
    (0, drawText_1.default)("Click to wake!", "#ffffff", gameWidth_1.default / 2, gameHeight_1.default / 2 - 24 + 2 - offset, 1, gameWidth_1.default, 1, "center", "top");
};
exports.default = drawBedHUD;
